<template>
  <div class="cmt-item" :class="{ has_child: childCount }">
    <div class="cmt-row">
      <div class="cmt-avatar">{{ initial }}</div>
      <div class="cmt-main">
        <div class="cmt-nick">
          {{ comment.user_name || '匿名用户' }}
          <em v-if="comment.is_owner" class="cmt-owner">作者</em>
        </div>
        <div class="cmt-text">{{ comment.content || '' }}</div>
        <div class="cmt-sub">
          <span class="cmt-time">{{ fmt(comment.created_at_remote) }}</span>
          <span class="cmt-like">♡<template v-if="comment.like_count"> {{ comment.like_count }}</template></span>
          <span class="cmt-replylink" @click="$emit('reply', comment)">回复</span>
        </div>
      </div>
    </div>

    <div v-if="childCount" class="cmt-children">
      <XhsCommentRow
        v-for="ch in visibleChildren"
        :key="ch.comment_id"
        :comment="ch"
        @reply="$emit('reply', $event)"
      />
      <button v-if="collapsed" class="cmt-more" @click="expand = true">
        展开更多 {{ childCount - 2 }} 条回复
      </button>
      <button v-else-if="expand" class="cmt-more" @click="expand = false">收起回复</button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'XhsCommentRow' })

const props = defineProps({
  comment: { type: Object, required: true },
})
defineEmits(['reply'])

const expand = ref(false)
const children = computed(() => props.comment.children || [])
const childCount = computed(() => children.value.length)
const visibleChildren = computed(() => (expand.value ? children.value : children.value.slice(0, 2)))
const collapsed = computed(() => childCount.value > 2 && !expand.value)
const initial = computed(() => {
  const n = props.comment.user_name || '?'
  return String(n).charAt(0).toUpperCase()
})

function fmt(v) {
  if (!v) return ''
  let ts = v
  if (typeof ts === 'string' && /^\d+$/.test(ts)) ts = Number(ts)
  if (typeof ts === 'number' && ts > 1e12) ts = Math.floor(ts / 1000)
  const d = new Date(typeof ts === 'number' ? ts * 1000 : v)
  if (isNaN(d.getTime())) return ''
  const diff = Date.now() - d.getTime()
  const min = 60000
  const hour = min * 60
  const day = hour * 24
  if (diff < min) return '刚刚'
  if (diff < hour) return `${Math.floor(diff / min)}分钟前`
  if (diff < day) return `${Math.floor(diff / hour)}小时前`
  if (diff < day * 30) return `${Math.floor(diff / day)}天前`
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  if (d.getFullYear() === new Date().getFullYear()) return `${mm}-${dd}`
  return `${d.getFullYear()}-${mm}-${dd}`
}
</script>

<style scoped>
.cmt-item { padding: 12px 0; border-bottom: 1px solid #f5f5f5; }
.cmt-row { display: flex; gap: 10px; }
.cmt-avatar {
  width: 32px; height: 32px; border-radius: 50%;
  background: linear-gradient(135deg, #ff5e7a, #ff7a3d);
  color: #fff; font-size: 14px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.cmt-main { min-width: 0; flex: 1; }
.cmt-nick { font-size: 13px; font-weight: 600; color: #333; display: flex; align-items: center; gap: 6px; }
.cmt-owner { font-style: normal; font-size: 11px; color: #ff2442; border: 1px solid #ffd4dd; border-radius: 4px; padding: 0 4px; }
.cmt-text { font-size: 13px; color: #1a1a1a; line-height: 1.6; margin: 4px 0; word-break: break-word; white-space: pre-wrap; }
.cmt-sub { display: flex; align-items: center; gap: 12px; color: #999; font-size: 12px; }
.cmt-time { font-size: 12px; }
.cmt-like { cursor: pointer; }
.cmt-replylink { color: #999; cursor: pointer; }
.cmt-replylink:hover { color: #ff2442; }
.cmt-children { margin: 8px 0 0 42px; padding-left: 12px; border-left: 2px solid #f0f0f0; }
.cmt-more { margin-top: 8px; background: none; border: none; color: var(--mp-accent, #ff2442); font-size: 12px; cursor: pointer; padding: 0; }
</style>
